export default __webpack_public_path__ + "pdf/ThirdPartyAuthorization-Audi.pdf";